import { render, staticRenderFns } from "./simpleReferralChain.vue?vue&type=template&id=5f253f79&scoped=true"
import script from "./simpleReferralChain.vue?vue&type=script&lang=js"
export * from "./simpleReferralChain.vue?vue&type=script&lang=js"
import style0 from "./simpleReferralChain.vue?vue&type=style&index=0&id=5f253f79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f253f79",
  null
  
)

export default component.exports